// IIFE to detect signup verification BEFORE React or Supabase SDK initializes
(function() {
  const hash = window.location.hash;
  if (hash) {
    const params = new URLSearchParams(hash.substring(1));
    const type = params.get('type');
    if (type === 'signup') {
      console.log('main.tsx IIFE: Detected signup verification, setting sessionStorage flag');
      sessionStorage.setItem('isSignupVerification', 'true');
      localStorage.removeItem('accountType');
      localStorage.removeItem('currentUser');
      
      const currentPath = window.location.pathname;
      if (currentPath === '/auth' || currentPath === '/') {
        console.log('main.tsx IIFE: Redirecting from', currentPath, 'to /role-selection');
        window.location.replace('/role-selection' + hash);
      }
    } else if (type === 'magiclink') {
      const currentPath = window.location.pathname;
      if (currentPath !== '/setup-password') {
        console.log('main.tsx IIFE: Detected magiclink, redirecting to /setup-password');
        window.location.replace('/setup-password' + hash);
      }
    }
  }
})();

import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { initSentry } from './lib/sentry';
import './index.css';

// Init Sentry BEFORE createRoot so any errors during the first render are
// captured. No-op if VITE_SENTRY_DSN is not set.
initSentry();

const root = createRoot(document.getElementById("root")!);
root.render(React.createElement(App));
